/**
 * Created: 2024-03-27
 * Purpose: Custom hook for displaying toast notifications
 */

import {useToast, UseToastOptions} from '@chakra-ui/react'

export function useFlashMessage() {
  const toast = useToast()

  const showMessage = (message: string, status: UseToastOptions['status'] = 'info', duration = 5000) => {
    toast({
      description: message,
      status,
      duration,
      isClosable: true,
      position: 'top'
    })
  }

  return {
    showMessage,
    showError: (message: string) => showMessage(message, 'error'),
    showSuccess: (message: string) => showMessage(message, 'success'),
    showWarning: (message: string) => showMessage(message, 'warning'),
    showInfo: (message: string) => showMessage(message, 'info')
  }
}
